import { Box, Container, Slider, makeStyles, withStyles } from '@material-ui/core';

import { DefaultPointsProps } from './PointsInputs';

import { primaryGreen, darkGreen, grayBlue } from 'src/data/colors';

import Input from './integerInputBase';

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
      height: 38,
      border: `1px solid ${grayBlue}`,
      padding: '8px 16px',
      borderRadius: 4,
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
    width: '100%',
  },
  value: {
    fontSize: 24,
    fontWeight: 500,
  },
  sliderContainer: {
    padding: '0 2px',
  },
}));

const PrettoSlider = withStyles({
  root: {
    width: 'calc(100% - 2px)',
    color: 'rgba(0, 0, 0, 0.10)',
    padding: '20px 0px',
    '&.Mui-disabled': {
      color: 'rgba(78, 100, 111, 0.25)',
    },
  },
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: '#fff',
    top: 24,
    border: `4px solid ${primaryGreen}`,
    outline: `1px solid ${darkGreen}`,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
    '&.Mui-disabled': {
      height: 12,
      width: 12,
      top: 22,
      backgroundColor: '#fff',
      outline: `1px solid rgba(78, 100, 111, 0.25)`,
      border: '4px solid rgba(78, 100, 111, 0.25)',
    },
  },
  valueLabel: {
    left: '-12px',
  },
  track: {
    height: 8,
    borderRadius: 4,
    color: primaryGreen,
    border: '1px solid rgba(0, 0, 0, 0.10)',
  },
  rail: {
    height: 8,
    borderRadius: 4,
    border: '1px solid rgba(0, 0, 0, 0.10)',
  },
  disabled: {
    '& $track': {
      backgroundColor: 'rgba(78, 100, 111, 0.25)',
    },
  },
})(Slider);

const IntegerInput = ({ onChange, value, point }: DefaultPointsProps) => {
  const classes = useStyles();
  const {
    entry: { range },
    readOnly,
  } = point;

  const handleChange = (event: unknown, newValue: number | number[]) => {
    onChange(point, Number(newValue));
  };

  return (
    <Container className={classes.inputContainer}>
      <Box display="flex" justifyContent="space-between">
        <Input
          value={Number(value)}
          keyData=""
          onKeyChange={handleChange}
          point={point}
          range={range}
          readOnly={readOnly}
          unit={point.unit}
          showButtons
        />
      </Box>
      {range?.min != null && range.max != null && (
        <Box className={classes.sliderContainer}>
          <PrettoSlider
            valueLabelDisplay="off"
            aria-label="pretto slider"
            value={value as number}
            onChange={handleChange}
            min={Number(range.min)}
            max={Number(range.max)}
            disabled={readOnly}
          />
        </Box>
      )}
    </Container>
  );
};

export default IntegerInput;
